export const getCustomerType = (lifetimeOrderCount: number | undefined) => {
  if (!lifetimeOrderCount) return 'prospect'
  if (lifetimeOrderCount === 1) return 'new customer'
  return 'existing customer'
}
